export enum HoverColor {
  Blue = "blue",
  Black = "black",
  Transparent = "transparent"
}

export const ICON_COLOR: string = "inherit";
export const ICON_SIZE: number = 16;
export const FONT_SIZE: number = 10;
